export const fonts = {
  fontFamily: "'Open Sans', sans-serif",
};

export const colors = {
  primary: "#1abc9c",
  secondary: "#748892",
};
